// extracted by mini-css-extract-plugin
export default {"backdrop":"styles_backdrop__fAghE","backdropIsOpen":"styles_backdropIsOpen__cRQcN","layer":"styles_layer__kW9p4"};